module.exports = __webpack_public_path__ + "static/media/remove-icon-square.129a3cc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/remove-icon-square.svg
// module id = 1498
// module chunks = 0